import { render, staticRenderFns } from "./tableOrders.vue?vue&type=template&id=3a3bda85&"
import script from "./tableOrders.vue?vue&type=script&lang=js&"
export * from "./tableOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports